<template>
  <span class="period-switch">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      class="period-switch__item"
      :class="{ 'period-switch__item--active': value === opt.value }"
      @click="select(opt.value)"
    >
      {{ opt.label }}
    </button>
  </span>
</template>

<script>
export const DAY_OPTIONS = [
  { value: 7, label: "7d" },
  { value: 15, label: "15d" },
  { value: 30, label: "30d" },
  { value: 90, label: "90d" },
];

export const MONTH_OPTIONS = [
  { value: 3, label: "3m" },
  { value: 6, label: "6m" },
  { value: 12, label: "12m" },
];

export default {
  name: "PeriodSwitch",
  props: {
    value: { type: Number, required: true },
    options: { type: Array, required: true }, // [{ value, label }]
  },
  methods: {
    select(value) {
      if (value !== this.value) {
        this.$emit("input", value);
        this.$emit("change", value);
      }
    },
  },
};
</script>

<style>
.period-switch {
  display: inline-flex;
  align-items: center;
}

.period-switch__item {
  background: none;
  border: none;
  padding: 2px 6px;
  font-size: 11px;
  color: #909399;
  cursor: pointer;
  transition: color 0.15s ease;
}

.period-switch__item:hover {
  color: #22418d;
}

.period-switch__item--active {
  color: #22418d;
  font-weight: 700;
}
</style>
